import Swiper, { Navigation, Thumbs } from 'swiper'
let init = false,
    swiper,
    fullSlider

function swiperSlider() {
    // if (window.innerWidth < 1200) {
    //     if (!init) {
    //         init = true
    //         swiper = new Swiper('.single-product-header-images', {
    //             modules: [Navigation, Thumbs],
    //             loop: true,
    //             slidesPerView: 'auto',
    //             spaceBetween: 10,
    //             navigation: {
    //                 nextEl: '.product-button-next',
    //                 prevEl: '.product-button-prev',
    //             },
    //         })
    //     }
    // } else if (init) {
    //     init = false
    //     swiper.destroy()
    // }

    fullSlider = new Swiper('.full-slider', {
        modules: [Navigation],
        loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: '.full-button-next',
            prevEl: '.full-button-prev',
        },
    })
}
document.addEventListener('DOMContentLoaded', swiperSlider)
// window.addEventListener('resize', swiperSlider)

document.body.addEventListener('click', function (e) {
    if (e.target.classList.contains('product-img')) {
        document.querySelector('.full-slider').classList.add('show')
        let swipeIndex = e.target.parentNode.dataset.swipeIndex
        fullSlider.slideTo(swipeIndex)
    }

    if (e.target.classList.contains('close-slider')) {
        document.querySelector('.full-slider').classList.remove('show')
    }
})
